module.exports = {
  US: {
    AL: 'Alabama',
    AK: 'Alaska',
    AS: 'American Samoa',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    MP: 'Northern Mariana Islands',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    AA: 'US Armed Forces - Americas',
    AE: 'US Armed Forces - Europe',
    AP: 'US Armed Forces - Pacific',
  },
  CA: {
    NL: 'Newfoundland and Labrador',
    PE: 'Prince Edward Island',
    NS: 'Nova Scotia',
    NB: 'New Brunswick',
    QC: 'Quebec',
    ON: 'Ontario',
    MB: 'Manitoba',
    SK: 'Saskatchewan',
    AB: 'Alberta',
    BC: 'British Columbia',
    YT: 'Yukon',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
  },
  /* eslint-disable quote-props */
  GB: {
    'Bath and North East Somerset': null,
    'Bedfordshire': null,
    'Berkshire': null,
    'Bristol': null,
    'Buckinghamshire': null,
    'Cambridgeshire': null,
    'Cheshire': null,
    'Cornwall': null,
    'County Durham': null,
    'Cumbria': null,
    'Derbyshire': null,
    'Devon': null,
    'Dorset': null,
    'East Riding of Yorkshire': null,
    'East Sussex': null,
    'Essex': null,
    'Gloucestershire': null,
    'Greater London': null,
    'Greater Manchester': null,
    'Hampshire': null,
    'Herefordshire': null,
    'Hertfordshire': null,
    'Isle of Wight': null,
    'Isles of Scilly': null,
    'Kent': null,
    'Lancashire': null,
    'Leicestershire': null,
    'Lincolnshire': null,
    'Merseyside': null,
    'Norfolk': null,
    'North Somerset': null,
    'North Yorkshire': null,
    'Northamptonshire': null,
    'Northumberland': null,
    'Nottinghamshire': null,
    'Oxfordshire': null,
    'Rutland': null,
    'Shropshire': null,
    'Somerset': null,
    'South Gloucestershire': null,
    'South Yorkshire': null,
    'Staffordshire': null,
    'Suffolk': null,
    'Surrey': null,
    'Tyne & Wear': null,
    'Warwickshire': null,
    'West Midlands': null,
    'West Sussex': null,
    'West Yorkshire': null,
    'Wiltshire': null,
    'Worcestershire': null,
    'Aberdeenshire': null,
    'Angus': null,
    'Argyll & Bute': null,
    'Ayrshire': null,
    'Banffshire': null,
    'Berwickshire': null,
    'Borders': null,
    'Caithness': null,
    'Clackmannanshire': null,
    'Dumfries & Galloway': null,
    'Dunbartonshire': null,
    'East Ayrshire': null,
    'East Dunbartonshire': null,
    'East Lothian': null,
    'East Renfrewshire': null,
    'Fife': null,
    'Highland': null,
    'Inverclyde': null,
    'Kincardineshire': null,
    'Lanarkshire': null,
    'Midlothian': null,
    'Moray': null,
    'North Ayrshire': null,
    'North Lanarkshire': null,
    'Orkney': null,
    'Perth & Kinross': null,
    'Renfrewshire': null,
    'Shetland': null,
    'South Ayrshire': null,
    'South Lanarkshire': null,
    'Stirlingshire': null,
    'West Dunbartonshire': null,
    'West Lothian': null,
    'Western Isles': null,
    'Blaenau Gwent': null,
    'Bridgend': null,
    'Caerphilly': null,
    'Cardiff': null,
    'Carmarthenshire': null,
    'Ceredigion': null,
    'Conwy': null,
    'Denbighshire': null,
    'Flintshire': null,
    'Gwynedd': null,
    'Isle of Anglesey': null,
    'Merthyr Tydfil': null,
    'Monmouthshire': null,
    'Neath Port Talbot': null,
    'Newport': null,
    'Pembrokeshire': null,
    'Powys': null,
    'Rhondda Cynon Taff': null,
    'Swansea': null,
    'Torfaen': null,
    'Vale of Glamorgan': null,
    'Wrexham': null,
    'Antrim': null,
    'Armagh': null,
    'Down': null,
    'Fermanagh': null,
    'Londonderry': null,
    'Tyrone': null,
  },
};
